define(function (require, exports, module) {
    'use strict';

    var UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function PathTooLongFail(stack, source) {
        UploadFail.apply(this, arguments);
    }

    PathTooLongFail.WEB_BACKEND_ERROR = 'name_too_long';

    PathTooLongFail.prototype = Object.assign(Object.create(UploadFail.prototype), {
        constructor: PathTooLongFail,
        className: 'PathTooLongFail',
        radarName: 'fail_{SOURCE}_path-too-long',
        message: [
            'Превышена длина пути.',
            '<a href="https://help.mail.ru/cloud_web/confines" rel="noopener" target="_blank">Подробнее</a>',
        ].join(' '),
    });

    module.exports = PathTooLongFail;
});
